import styled from 'styled-components';
import Typography, { TypographyProps } from '@material-ui/core/Typography';

export const BoldTypography = styled(Typography)<TypographyProps>`
  && {
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  }
`;
